import React from "react";

interface TimeInputFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
}

const TimeInputField: React.FC<TimeInputFieldProps> = ({
  id,
  value,
  onChange,
  options,
}) => {
  return (
    <select
      id={id}
      name={id}
      value={value}
      onChange={onChange}
      className="focus:border-soluud-primary focus:ring-soluud-primary/30 block w-1/2 rounded-lg border border-gray-300 py-2 pr-10 pl-3 text-base transition-colors duration-150 focus:ring-2 focus:outline-none sm:text-sm"
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default TimeInputField;
